var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidgetIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#widget_icon_svg__clip0_343_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.05 22a1.429 1.429 0 01-1.43-1.428v-5.404a1.429 1.429 0 011.43-1.429h5.403a1.428 1.428 0 011.429 1.428v5.405A1.428 1.428 0 0119.453 22H14.05zM3.427 22A1.428 1.428 0 012 20.572v-5.404a1.429 1.429 0 011.428-1.429h5.404a1.428 1.428 0 011.429 1.428v5.405A1.428 1.428 0 018.832 22H3.428zm12.313-9.92l-3.822-3.82a1.428 1.428 0 010-2.02l3.822-3.822a1.428 1.428 0 012.02 0l3.82 3.821a1.428 1.428 0 010 2.02l-3.82 3.82a1.428 1.428 0 01-2.02 0zm-12.313-.7A1.428 1.428 0 012 9.95V4.548a1.428 1.428 0 011.428-1.429h5.404a1.428 1.428 0 011.429 1.429V9.95a1.429 1.429 0 01-1.429 1.428H3.428z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "widget_icon_svg__clip0_343_86"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgWidgetIcon;